const pathObj = {
  loginUser: "/v1/user/login",
  registerUser: "/v1/user/register",
  userSendOtp: "/v1/user/user-send-otp",
  verifyOtp: "/v1/user/register-verify-otp",
  sendOtp: "/v1/user/send-otp",
  editStake: "/v1/user/edit-one-click-stake",

  refreshToken: "/v1/user/refresh-token",
  seriesList: "/v1/user/match/series",
  matchList: "/v1/user/match/mobile-list",
  fancyList: "/v1/user/match/fancy-list",
  refreshAmount: "/v1/user/refresh-amount",
  userProfile: "/v1/user/profile",
  userProfileUpdate: "/v1/user/profile-update",
  userEditStake: "/v1/user/edit-stake",
  greyhoundList: "/v1/user/match/greyhound-list",
  horseList: "/v1/user/match/horse-list",
  userEditOneClickStake: "/v1/user/edit-one-click-stake",
  activityLogs: "/v1/user/activity-logs",
  changePassword: "/v1/user/change-password", getTossBets: "/v1/user/match/my-toss-bets",
  forgotPassword: "/v1/user/forgot-password",
  transactionLogs: "/v1/user/transaction/logs", getBookmakerWifiBets: "/v1/user/match/my-wifi-bookmaker-bets",
  accountStatement: "/v1/user/transaction/bet-logs",
 betfairPlaceBetUpdate: "/v1/user/match/edit-betfaire-place-bet",
  getPromotional: "/v1/user/get-promotional-offer",
  matchDetail: "/v1/user/match/detail",
  matchScore: "/v1/user/match/score",
  sportsList: "/v1/user/sport/list",
  inPlayCount: "/v1/user/sport/inplay-count",
  betfairPlaceBet: "/v1/user/match/betfaire-place-bet",
  soccerPlaceBet: "/v1/user/match/soccer-place-bet",
  currentBetsCount: "/v1/user/match/current-bet-count",
  tennisPlaceBet: "/v1/user/match/tennis-place-bet",
  userInPlaySport: "/v1/user/sport/mobile",
  bookmakerBet: "/v1/user/match/bookmaker-place-bet",
  betPosition: "/v1/user/match/get-bet-positions",
  betEventsBetPosition: "/v1/user/match/get-events-bet-positions",
  multiEventPlaceBet: "/v1/user/match/multiple-event-place-bet",
  getCurrentBetsExchanges: "/v1/user/match/my-bets",
  cancelUnmatchedBets: "/v1/user/match/clear-unmatched-bet",
  getBookmakerBets: "/v1/user/match/my-bookmaker-bets",
  getLottery: "/v1/user/match/my-lottery-bets",
  getFancyBets: "/v1/user/match/my-fancy-bets",
  getSportsBook: "/v1/user/match/my-sport-book-bets",
  fancyBetPlace: "/v1/user/match/fancy-place-bet",
  diamondfancyBetPlace: "/v1/user/match/diamond-fancy-place-bet",
  multiMarket: "/v1/user/sport/multi-market",
  preminumFancyBets: "/v1/user/match/premium-fancy-place-bet",
  linemarketBets: "/v1/user/match/line-market-bet",
  addMatchInMultiMarket: "/v1/user/sport/multi-market",
  getPremiumFancy: "/v1/cron/premium-fancy",
  getMatchOdds: "/v1/cron/match-odds",
  getBetsData: "/v1/user/match/events-bets",
  getHistory: "/v1/user/match/bet-history",
  messageList: "/v1/user/message/list",
  userSubscribe: "/v1/user/subscribe",
  adminSetting: "/v1/user/site-setting/site-setting-list",
  searchEvent: "/v1/user/match/search-list",
  tournamentList: "/v1/user/match/list",
  currentBets: "/v1/user/match/current-bets",
  mobileCurrentBets: "/v1/user/match/mobile-current-bets",
  betFancyPosition: "/v1/user/match/fancy-bet-positions",
  bookPosition: "/v1/user/match/fancy-bet-run-positions",
  betPremiumFancyPosition: "/v1/user/match/sport-book-bet-positions",
  doLoginAndLaunchGame: "/v1/wallet/doLoginAndLaunchGame",
  casinoAmountAdd: "/v1/user/casino-amount-add",
  withdrawCasinoAmount: "/v1/wallet/withdraw",
  easytogoCasinoAmountAdd: "/v1/user/easytogo-casino-amount-add",
  doLoginAndLaunchEasyToCasino: "/v1/wallet/doLoginAndLaunchEasyToCasino",
  doLoginAndLaunchEasyToCasinoNew: "/v1/wallet/doLoginAndLaunchAuroCasino",
  bookmakerOdds: "/v1/cron/bookmaker-odds",
  doLoginAndLaunchIQCasino: "/v1/wallet/doLoginAndLaunchIQCasino",
  lotteryPlaceBet: "/v1/user/match/lottery-place-bet",

  doLoginAndLaunchEasyToCasinoNormal: "/v1/wallet/doLoginAndLaunchCasino",
  gameList: "/v1/wallet/gameList",
  casinoWalletLogin: "/v1/wallet/login",
  awcBalance: "/v1/wallet/get-awc-balance",
  egtBalance: "/v1/wallet/get-egt-balance",
  unMatchedBets: "/v1/user/match/current-group-unmatch-bets",
  clearBets: "/v1/user/match/clear-unmatched-bet?",
  getSetting: "/v1/user/website-setting",
  beforeBetPlace: "/v1/user/match/check-bet-price",
  easytogoCasinoAmountAdd: "/v1/user/easytogo-casino-amount-add",
  doLoginAndLaunchEasyToCasino: "/v1/wallet/doLoginAndLaunchEasyToCasino",
  getEGTCasinoAmount: "/v1/wallet/getEGTCasinoAmount",
  withdrawEgtCasinoAmount: "/v1/wallet/withdraw-egt-balance",
  profitLoss: "/v1/user/match/profit-loss",
  tossBetPlace: "/v1/user/match/place-toss-bet",
  tieBetPlace: "/v1/user/match/place-tie-bet",
  p2ptransfer: "/v1/user/transaction/p2p-transfer",
  p2ptransferLog: "/v1/user/transaction/p2p-logs",
  casinoGetResult: "/v1/wallet/client-transaction-history",
  casionStatement: "/v1/user/match/casino-bet-history",
  getFancyOdds: "/v1/cron/fancy-odds",
  lineMarket: "/v1/cron/odd-even-odds",

  depositAmount: "/v1/user/deposit-amount",
  getBank: "/v1/user/get-bank-list",
  getBankDetail: "/v1/user/get-bank-details",
  withdrawal: "/v1/user/withdrawal-amount",
  reciptUpload: "/v1/user/receipt-upload",
  getBanner: "/v1/user/get-home-banners",
  affiliate: "/v1/user/agent-register",
  getIcon: "/v1/user/website-setting",
  getParlyBets: "/v1/user/match/my-parlay-bets",
  depositHistory: "/v1/user/deposit-history",
  withDrawHistory: "/v1/user/withdrawal-history",
  cancelRequest: "/v1/user/withdrawal-cancel-request",
  refralList: "/v1/user/referral-list",
  doLoginAndLaunchIQCasino: "/v1/wallet/doLoginAndLaunchIQCasino",
  getTurnover: "/v1/user/get-turnover",
  refralList: "/v1/user/referral-list",
  doLoginAndLaunchRoyaCasino: "/v1/wallet/doLoginAndLaunchRoyalCasino",
};

export default pathObj;
